import { render } from "./MyfundDetail.vue?vue&type=template&id=c05c409a&scoped=true"
import script from "./MyfundDetail.vue?vue&type=script&lang=js"
export * from "./MyfundDetail.vue?vue&type=script&lang=js"

import "./MyfundDetail.vue?vue&type=style&index=0&id=c05c409a&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c409a"]])

export default __exports__